import { useMemo } from "react";
import { useIntl } from "react-intl";
import { TestType } from "@app/provider/testData/types";
import { titles } from "../components/common/testTitle";

const useTestTitles = () => {
  const intl = useIntl();

  return useMemo(
    (): Record<TestType, string> => ({
      [TestType.RENASIGHT]: intl.formatMessage(titles.testRenasightTitle),
      [TestType.PROSPERA]: intl.formatMessage(titles.testProsperaTitle),
      [TestType.HORIZON]: intl.formatMessage(titles.testHorizonTitle),
      [TestType.PANORAMA]: intl.formatMessage(titles.testPanoramaTitle),
      [TestType.EMPOWER]: intl.formatMessage(titles.testEmpowerTitle),
      [TestType.SIGNATERA]: intl.formatMessage(titles.testSignateraTitle),
      [TestType.ALTERA]: intl.formatMessage(titles.testAlteraTitle),
      [TestType.VISTARA]: intl.formatMessage(titles.testVistaraTitle),
      [TestType.SPECTRUM]: intl.formatMessage(titles.testSpectrumTitle),
      [TestType.ANORA]: intl.formatMessage(titles.testAnoraTitle),
      [TestType.SINGLE_GENE_NIPT]: intl.formatMessage(titles.testSGNIPTTitle),
      [TestType.LATITUDE]: intl.formatMessage(titles.testLatitudeTitle),
      // same id as titles.testDpydTitle — inline keeps Record<TestType, string> stable if defineMessages inference lags
      [TestType.DPYD]: intl.formatMessage({
        id: "common.testcards.dpyd",
        defaultMessage: "DPYD Genotyping",
      }),
    }),
    [intl]
  );
};

export default useTestTitles;
